import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Upload } from "lucide-react";

export default function AdminSponsors() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", website: "", tier: "Partner", logo_file_id: "" });
  const load = async () => setItems((await api.get("/sponsors")).data);
  useEffect(() => { load(); }, []);
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file); fd.append("folder", "sponsors");
    try { const r = await api.post("/files/upload", fd, { headers: {"Content-Type":"multipart/form-data"}}); setForm({...form, logo_file_id: r.data.file_id}); toast.success("Uploaded"); }
    catch { toast.error("Upload failed"); }
  };
  const create = async () => { if(!form.name) return toast.error("Name required"); await api.post("/admin/sponsors", form); toast.success("Sponsor added"); setForm({ name: "", website: "", tier: "Partner", logo_file_id: "" }); load(); };
  const del = async (id) => { await api.delete(`/admin/sponsors/${id}`); load(); };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Partners</div>
      <h1 className="font-display text-4xl mt-2">Sponsors</h1>
      <div className="mt-6 p-6 bg-[#0B132B] border border-white/10 rounded grid md:grid-cols-5 gap-3">
        <input placeholder="Name" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm md:col-span-2" data-testid="sponsor-name"/>
        <input placeholder="Website URL" value={form.website} onChange={(e)=>setForm({...form, website: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm"/>
        <select value={form.tier} onChange={(e)=>setForm({...form, tier: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm">
          {["Title","Powered By","Associate","Partner"].map(t=><option key={t} value={t} className="bg-[#0B132B]">{t}</option>)}
        </select>
        <label className="flex items-center gap-2 border border-dashed border-white/15 px-3 py-2 cursor-pointer text-xs"><Upload size={14} className="text-[#39FF14]"/>{form.logo_file_id?"✓":"Logo"}<input type="file" accept="image/*" className="hidden" onChange={(e)=>upload(e.target.files?.[0])}/></label>
        <button onClick={create} data-testid="create-sponsor" className="md:col-span-5 py-2 bg-[#39FF14] text-black font-bold uppercase tracking-widest text-xs">Add Sponsor</button>
      </div>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((s) => (
          <div key={s.id} className="p-4 bg-[#0B132B] border border-white/10 rounded relative">
            {s.logo_file_id ? <img src={fileUrl(s.logo_file_id)} alt={s.name} className="h-16 mx-auto object-contain"/> : <div className="h-16 grid place-items-center font-display text-xl">{s.name}</div>}
            <div className="mt-3 text-center">
              <div className="text-sm">{s.name}</div>
              <div className="text-xs text-[#FFD700]">{s.tier}</div>
            </div>
            <button onClick={()=>del(s.id)} className="absolute top-2 right-2 p-1 text-[#FF2442]"><Trash2 size={14}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
